import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '../../features';
import { actions } from '../../features/bestFriends';
import { getQueryParam } from '../../lib/utils';
import { ReportError } from '../../models/report/ReportError';
import { ReportFailed } from '../shared/report/ReportFailed';

export const ReportFailedDialog: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const chars = useSelector(
    (state: RootState) => state.bestFriends.reportErrorPayload?.invalidChars
  );
  const errorType = getQueryParam(location.search || '', 'type') as ReportError['type'];

  useEffect(() => {
    return () => {
      dispatch(actions.resetReportStatus());
    };
  }, [dispatch]);

  return <ReportFailed errorType={errorType} invalidChar={chars} />;
};
